import Box from '@mui/material/Box';
import UploadIcon from '../icon/UploadIcon';

import type { ReactNode } from 'react';

const DropBox = ({
    children,
    highlight,
}: {
    children?: ReactNode;
    highlight?: boolean;
}) => (
    <Box
        sx={{
            m: 4,
            p: 5,
            textAlign: 'center',
            border: '2px dashed',
            borderColor: highlight ? '#6366f1' : '#374151',
            backgroundColor: highlight ? 'rgba(99, 102, 241, 0.1)' : '#0f0f23',
            transition: 'all 0.2s ease',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.5,
            fontWeight: 700,
            textTransform: 'uppercase',
            letterSpacing: '0.05em',
            color: highlight ? '#6366f1' : '#9ca3af',
        }}
    >
        {children} <UploadIcon />
    </Box>
);

export default DropBox;
